import { z } from "zod";

export type CustomerDataParsed = z.infer<typeof CustomerDataSchema>;
export const CustomerDataSchema = z.object({
  customerId: z.number(),
  customerNumber: z.string().nullable(),
  companyName: z.string().nullable(),
  firstName: z.string().nullable(),
  middleName: z.string().nullable(),
  lastName: z.string().nullable(),
  dateOfbirth: z.string().nullable(),
  address1: z.string().nullable(),
  address2: z.string().nullable(),
  zipCode: z.string().nullable(),
  city: z.string().nullable(),
  stateId: z.number().nullable(),
  countryId: z.number().nullable(),
  hPhone: z.string().nullable(),
  bPhone: z.string().nullable(),
  cPhone: z.string().nullable(),
  fax: z.string().nullable(),
  licenseNumber: z.string().nullable(),
  licenseCategory: z.string().nullable(),
  email: z.string().nullable(),
  hstNumber: z.string().nullable(),
  active: z.boolean(),
  countryName: z.string().nullable(),
  stateName: z.string().nullable(),
  stateCode: z.string().nullable(),
  insuranceCompany: z.string().nullable(),
  policyNumber: z.string().nullable(),
  insuranceExpiryDate: z.string().nullable(),
  insuranceCountry: z.coerce.string().nullable(),
  insuranceProvince: z.coerce.string().nullable(),
  creditCardType: z.string().nullable(),
  creditCardNo: z.string().nullable(),
  creditCardExpiryDate: z.string().nullable(),
  creditCardCVSNo: z.string().nullable(),
  insuranceState: z.string().nullable(),
  billingAddress1: z.string().nullable(),
  billingCity: z.string().nullable(),
  billingZipCord: z.string().nullable(),
  insuranceClaim: z.string().nullable(),
  billStateName: z.string().nullable(),
  billingStateId: z.number().nullable(),
  billingCountyId: z.number().nullable(),
  customerType: z.string().nullable(),
  billCountryName: z.string().nullable(),
  password: z.string().nullable(),
  licenseIssueDate: z.string().nullable(),
  licenseExpiryDate: z.string().nullable(),
  licenseIssueState: z.string().nullable(),
  passportNo: z.string().nullable(),
  passportIssueDate: z.string().nullable(),
  passportExpairyDate: z.string().nullable(),
  locationId: z.number().nullable(),
  locationName: z.string().nullable(),
  creditCardBillingZipCode: z.string().nullable(),
  rateName: z.string().nullable(),
  productionName: z.string().nullable(),
  nameOnCard: z.string().nullable(),
  customerImage: z.string().nullable(),
  drivingExperience: z.string().nullable(),
  isBlackListed: z.boolean(),
  blackListId: z.number().nullable(),
  blackListDescription: z.string().nullable(),
  blackListDate: z.string().nullable(),
  blackListReason: z.number().nullable(),
  licenseCountryId: z.number().nullable(),
  accoutNameInBank: z.string().nullable(),
  accountNumber: z.string().nullable(),
  bsb: z.any().nullable(),
  emergencyContactNo: z.string().nullable(),
  companyRegNo: z.string().nullable(),
  isSMSOpted: z.boolean(),
  isEmailOpted: z.boolean(),
  qboReferenceId: z.any().nullable(),
  ticketFlag: z.number().nullable(),
  clientId: z.number().nullable(),
  createdBy: z.number().nullable(),
  userName: z.string().nullable(),
  paymentTerms: z.number().nullable(),
  isTaxExempt: z.boolean(),
  licenseCountryName: z.string().nullable(),
  bankName: z.string().nullable(),
  bankSwiftCode: z.string().nullable(),
  createdByName: z.string().nullable(),
  lastUpdatedBy: z.string().nullable(),
  insuranceCountryName: z.string().nullable(),
  dmsid: z.coerce.string().nullable(),
  insuranceCompanyName: z.string().nullable(),
  insuranceCompanyAddress: z.string().nullable(),
  insuranceContactPhone: z.string().nullable(),
  insuranceContactEmail: z.string().nullable(),
  insuranceProvinceName: z.string().nullable(),
  customerImageList: z.array(z.string()),
  employmentType: z.string().nullable(),
  brokerName: z.string().nullable(),
  brokerAddress: z.string().nullable(),
  brokerPhone: z.string().nullable(),
  brokerEmail: z.string().nullable(),
});
